import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'error-dialog',
  templateUrl: './error-dialog.component.html'
})
export class ErrorDialogComponent {

  @Input() errorContents!: string[];
  @Input() hidden: boolean = false;

  constructor(
    private router: Router
  ) {}

  close() {
    this.hidden = !this.hidden;
  }
}